import { useAtom } from "jotai";
import { DebugSheet } from "./DebugSheet";
import { debugSheetPayloadAtom } from "./debug-sheet-store";

export function DebugSheetHost({ conversationId }: { conversationId: string }) {
  const [payload, setPayload] = useAtom(debugSheetPayloadAtom);
  const isOpen = payload?.conversationId === conversationId;

  return (
    <DebugSheet
      groupId={payload?.groupId ?? ""}
      conversationId={conversationId}
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) setPayload(null);
      }}
      debugData={isOpen ? (payload?.data ?? null) : null}
      canViewLogs={payload?.canViewLogs ?? false}
    />
  );
}
